import { useState, useEffect } from 'react';
import './App.css';
import Membership from './pages/Membership/Membership';
import Services from './pages/Services/Services';
import CancelResult from './pages/CancelResult/CancelResult';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // 从路径中获取页面
    const getPathPage = () => {
      const path = window.location.pathname;
      if (path === '/' || path === '') return 'home';
      return path.replace('/', '');
    };

    setCurrentPage(getPathPage());

    const handlePopState = () => {
      setCurrentPage(getPathPage());
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigateTo = (page) => {
    const newPath = page === 'home' ? '/' : `/${page}`;
    window.history.pushState(null, '', newPath);
    setCurrentPage(page);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'membership':
        return <Membership />;
      case 'services':
        return <Services />;
      case 'cancel-result':
        return <CancelResult />;
      default:
        return (
          <main className="App-main">
            <section className="hero">
              <div className="construction">
                <span className="construction-icon">🏋️</span>
                <h2>网站正在建设中</h2>
                <p>精彩内容即将呈现，敬请期待...</p>
              </div>
            </section>
          </main>
        );
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1 onClick={() => navigateTo('home')} style={{ cursor: 'pointer' }}>趣炼</h1>
        <p>智能门禁 · 会员管理 · 私教课程</p>
        {currentPage === 'home' && (
          <nav className="nav-links">
            <button onClick={() => navigateTo('membership')}>会员权益</button>
            <button onClick={() => navigateTo('services')}>服务介绍</button>
          </nav>
        )}
      </header>

      {renderPage()}

      <footer className="App-footer">
        <div className="footer-content">
          <p className="copyright">© 2026 趣炼. All rights reserved.</p>
          <div className="filing-info">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="filing-link"
            >蜀ICP备2026013910号-1</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
